import moment from "jalali-moment";
import React, { useEffect, useState } from "react";
import shapedevider from "../../../assets/img/icons/shape-divider.svg";
import clock from "../../../assets/img/icons/timer.svg";
import Filterrow from "../../common/Filterrow";
import PersianNumber from "../../shared/PersianNumber";
import SpecialTipsCarousel from "./SpecialTipsCarousel";
const SpecialTips = ({ infoHome }) => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(new Date());
    }, 1000);
    return () => clearInterval(intervalId);
  }, []);

  const hours = time.getHours().toString().padStart(2, "0");
  const minutes = time.getMinutes().toString().padStart(2, "0");
  const seconds = time.getSeconds().toString().padStart(2, "0");
  return (
    <div className="SpecialTips mb-[56px]">
      <div className="container">
        <div className="flex justify-between items-center">
          <div className="title--home">
            <img src={shapedevider} />
            <h4 className="font-[700] text-[40px] text-[#292D32]">
              تـخـفـیـف هـای ویـژه
            </h4>
            <div className="text-[20px] text-[#797D82] title--home--p">
              بهترین اقامتگاه ها را با مناسب ترین قیمت ها و امکانات رزرو کنید{" "}
            </div>
          </div>
          <div className="common-bg py-[13px] px-[33px] flex items-center SpecialTips--time">
            <img src={clock} />
            <div className="white-bg flex flex-row-reverse items-center justify-center mx-[10px]">
                <PersianNumber number={(24 -
              hours).toString().length === 1
              ? `0${24 - hours}`
              : 24 - hours} />:
                 <PersianNumber number={(60 -
              minutes).toString().length === 1
              ? `0${60 - minutes}`
              : 60 - minutes} />:
               <PersianNumber number={(60 -
              seconds).toString().length === 1
              ? `0 ${60 - seconds}`
              : 60 - seconds} />
               </div>
            <div className="text-[24px] text-[#292D32]">زمان باقی مانده</div>
          </div>
        </div>
        <div className="my-[40px]">
          <SpecialTipsCarousel infoHome={infoHome} />
        </div>
      </div>
    </div>
  );
};

export default SpecialTips;
